(function () {
    'use strict';

    angular
        .module('employeeControllers')
        .controller('EmployeeSystemBusinessTasksController', Controller);

    Controller.$inject = ['$scope', '$translate', 'businessTasks', 'businessTaskSystemRoles'];

    function Controller($scope, $translate, businessTasks, businessTaskSystemRoles) {

        $scope.isRestrictedZone = (businessTasks.IsRestrictedZone === true) ||
                                  (businessTaskSystemRoles.IsRestrictedZone === true);

        $translate('iam.employee.businessTasks.pageTitle').then(function(translation) {
            $scope.updateTopBar(translation, 'fa fa-tasks');
        });

        $scope.businessProcesses = getBusinessProcesses();

        function getBusinessProcesses() {
            return _.chain(businessTasks)
                .groupBy('BusinessProcessId')
                .map(function (tasksByProcess) {
                    return _.assign({ businessTasks: addSystemRolesToTasks(tasksByProcess) }, _.pick(tasksByProcess[0], ['BusinessProcessName']))
                })
                .value();
        }

        function addSystemRolesToTasks(tasks) {
            return _.chain(tasks)
                .map(function (task) {
                    return _.assign(task, { systems: getSystems(task.BusinessTaskID) })
                })
                .value();
        }

        function getSystems(businessTaskID) {
            return _.chain(businessTaskSystemRoles)
                .filter({ BusinessTaskID: businessTaskID })
                .groupBy('SystemID')
                .map(function (sysRoles) {
                    return _.assign({ systemRoles: sysRoles }, _.pick(sysRoles[0], ['SystemID', 'SystemName', 'SystemComment']))
                })
                .value();
        }
    }
})();